<script lang="ts">
	import { onDestroy } from 'svelte';
	import { netWorkErrorStore } from '../../store/network_error';
	import { QuestionRhombus, Reload } from '../icons';
	import { Toast, tryConnectServer } from '../scripts/util';

	let has_connected_error = true;

	const unsubscribe = netWorkErrorStore.subscribe(value => {
		has_connected_error = value;
	});

	async function retryConnect() {
		Toast.loadWithProcess(tryConnectServer(), {
			loading: 'connecting...',
			success: '接続成功',
			error: '接続エラーです。',
		}).then(r => {
			netWorkErrorStore.offErrorState();
		});
	}

	$: {
		const l = $netWorkErrorStore;
		// console.log('NetWorkTest: Error.', l);
	}
	onDestroy(unsubscribe);
</script>

{#if has_connected_error}
	<div class="wrapper">
		<div class="status-alert">
			<div class="main-float fl j-c">
				<QuestionRhombus size="1.5em" />
				<p>NetWork Error.</p>
				<button class="btn btn-link" on:click={retryConnect}>
					<Reload size="1.3em" />
				</button>
			</div>
		</div>
	</div>
{/if}

<style lang="scss" scoped>
	$width: 300px;
	.wrapper {
		position: fixed;
		top: 1%;
		width: 200px;
		height: 60px;
		left: calc(50% - 125px);
		.status-alert {
			position: relative;
			padding: 1rem;
			border-radius: 0;
			height: 100%;
			animation: slide-in-top 0.5s;
			.main-float {
				position: absolute;
				z-index: 1;
				background-color: #fff;
				width: 98%;
				height: 94%;
				left: 1%;
				top: 3%;
				border-radius: 1rem;

				p {
					margin: 0;
					margin-left: 0.5rem;
				}
			}
			&::after {
				position: absolute;
				content: '';
				background: linear-gradient(0.25turn, #ff8383, #ffb3b3, #fdc275);
				width: 100%;
				height: 100%;
				bottom: 0;
				left: 0;
				background-size: 200% 200%; /*サイズを大きくひきのばす*/
				animation: alert-bottom-bar-animation 10s ease infinite;
				border-radius: 1rem;
			}
		}
	}
	@keyframes pop-up {
		0% {
			transform: scale(1.3);
		}
		30% {
			transform: scale(0.8);
		}
		60% {
			transform: 1.2;
		}
		80% {
			transform: 0.9;
		}
		88% {
			transform: 1.1;
		}
		94% {
			transform: 0.95;
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes slide-in-top {
		0% {
			transform: translateY(-100px);
		}
		80% {
			transform: translateY(3px);
		}
		100% {
			transform: translateY(0);
		}
	}

	@keyframes alert-bottom-bar-animation {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
</style>
